import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import {
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import ConfigurationService from "../../../services/configuration-service";
import ExpandedComponent from "./row-expand.component.js";
import moment from "moment";
import { agentCommissionList } from "./../../../actions/commission-action";
import Confirmation from "../../common/modals/confirmation.component.js";

const AgentCommissionListView = () => {
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [commissionList, setCommissionList] = useState([]);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [row, setRow] = useState({});
  const [selectedRows, setSelectedRows] = React.useState([]);
  const selectRows = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const columns = [
    {
      name: "Group Name",
      selector: (row) => row.group_name,
      sortable: true,
    },
    {
      name: "Payin Type",
      selector: (row) => row.payin.commission_type,
      sortable: true,
    },
    {
      name: "Payout Type",
      selector: (row) => row.payout.commission_type,
      sortable: true,
    },
    {
      name: "Status",
      sortable: true,
      button: true,
      selector: (row) => row.status,
      style: (row) => ({ justifyContent: "flex-start" }),
      cell: (row) => (
        <>
          <div
            className={`badge badge-pill ${getStatusClass(
              row.status
            )} font-size-12`}
            style={{
              backgroundColor:
                row.group_id && !!expanded[row.group_id] ? "white" : "",
            }}
          >
            {row.status}
          </div>
        </>
      ),
      // cell: row =>
      //  <>
      //     <span className="mgh">
      //       <img style={{width: '15px'}} src="https://cdn-icons-png.flaticon.com/512/1011/1011500.png" />
      //     </span>
      //     </>
    },
    {
      name: "Created At",
      selector: (row) =>
        row.created_on
          ? moment(row.created_on, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")
          : "",
      sortable: true,
    },
    {
      name: "Updated At",
      selector: (row) =>
        row.updated_on
          ? moment(row.updated_on, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")
          : "-",
      sortable: true,
    },
    {
      name: "Actions",
      button: true,
      cell: (row) => (
        <>
          <a
            className={`fview tooltip`}
            style={{ cursor: "pointer" }}
            onClick={() => viewCommsionGroup(row.group_id)}
          >
            <i
              className={`fa ${
                row.status === "Rejected" ? "fa-eye disable" : "fa-eye"
              }`}
              style={{
                color:
                  row.group_id && !!expanded[row.group_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">View</span>
          </a>
          <a
            className="flock tooltip"
            onClick={() => changeStatus(row)}
            href="#"
          >
            <i
              className={`fa ${
                row.status === "Initiated" || row.status === "Rejected"
                  ? "fa-lock disable"
                  : row.status === "Suspended"
                  ? "fa-unlock"
                  : "fa-lock"
              }`}
              style={{
                color:
                  row.group_id && !!expanded[row.group_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">
              {" "}
              <>
                {row.status !== "Active"
                  ? "UnLock"
                  : "Lock" // Or whatever you want to show if the status is 'Active'
                }
              </>
            </span>
          </a>
          <a
            onClick={() => editCommission(row)}
            className={`fedit tooltip ${
              row.status === "Rejected" || row.status === "Suspended"
                ? "disable"
                : ""
            }`}
            href="#"
          >
            <i
              className={`fa ${
                row.status === "Rejected" || row.status === "Suspended"
                  ? "fa-edit disable"
                  : "fa-edit"
              }`}
              style={{
                color:
                  row.group_id && !!expanded[row.group_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">Edit</span>
          </a>
          <a
            className="ftrash tooltip"
            onClick={() => deleteAgentCommission(row)}
            href="#"
          >
            <i
              className="fa fa-trash"
              style={{
                color:
                  row.group_id && !!expanded[row.group_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">Delete</span>
          </a>
          <a
            className="fell tooltip"
            href="#"
            style={{ paddingRight: "25px", cursor: "pointer" }}
          >
            <i
              className="fa fa-ellipsis-v"
              style={{
                color:
                  row.group_id && !!expanded[row.group_id] ? "white" : "black",
              }}
              aria-hidden="true"
            />
            <span className="tooltiptext">More</span>
          </a>
        </>
      ),
    },
  ];

  const viewCommsionGroup = (id) => {
    navigate(`/view-commission-group/${id}`);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "badge-soft-success";
      case "Initiated":
        return "badge-soft-pending";
      case "Rejected":
        return "badge-soft-warning";
      case "Suspended":
        return "badge-soft-received";
      case "Deleted":
        return "badge-soft-danger";
      default:
        return "";
    }
  };

  const editCommission = (row) => {
    navigate("/edit-commission-group/" + row.group_id);
  };

  const changeStatus = (row) => {
    setModalShow(true);
    setRow({
      group_id: row.group_id,
      status: row.status,
      modalId: "statusChangeAgentCommission",
    });
  };

  const deleteAgentCommission = (row) => {
    setModalShow(true);
    setRow({
      group_id: row.group_id,
      status: row.status,
      modalId: "deleteAgentCommission",
    });
  };

  const deleteConfirmation = () => {
    setLoading(true);
    ConfigurationService.deleteAgentCommission(row.group_id)
      .then((response) => {
        toast.success(MESSAGES.AGENT_COMMSION_DELETED);
        getAgentCommissionList();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
        setModalShow(false);
      });
  };

  const updateStatus = () => {
    console.log(row.status);
    if (row.modalId == "statusChangeAgentCommission") {
      const suspended = [];
      const resume = [];
      if (row.status.toLowerCase() == "active") {
        suspended.push(row.group_id);
        suspendAgentCommission(suspended);
      } else {
        resume.push(row.group_id);
        resumeAgentCommission(resume);
      }
    } else if (row.modalId == "statusChangeCommisonSuspend") {
      const suspended = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].status_id.toLowerCase() == "a") {
          suspended.push(selectedRows[i].group_id);
        }
      }
      suspendAgentCommission(suspended);
    } else if (row.modalId == "statusChangeCommisionLimitResume") {
      const resume = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].status_id.toLowerCase() == "s") {
          resume.push(selectedRows[i].group_id);
        }
      }
      resumeAgentCommission(resume);
    } else {
      deleteConfirmation();
    }
  };

  const resumeAgentCommission = (resume) => {
    setLoading(true);
    //if(resume.length == 1){
    ConfigurationService.resumeAgentCommission(resume)
      .then((response) => {
        toast.success(MESSAGES.AGENT_COMSION_RESUME);
        getAgentCommissionList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([]);
      })
      .catch((error) => {
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }

        setLoading(false);
      });
    //}
  };

  const suspendAgentCommission = (suspended) => {
    setLoading(true);
    //if(suspended.length == 1){
    ConfigurationService.suspendAgentCommission(suspended)
      .then((response) => {
        toast.success(MESSAGES.AGENT_COMMSION_SUSPENDED);
        getAgentCommissionList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([]);
      })
      .catch((error) => {
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }

        setLoading(false);
      });
    //  }
  };

  const formatCreatedAt = (date) => {
    const parsedDate = moment(date, "DD-MM-YYYY HH:mm:ss");
    // Change the format according to your needs
    return moment(parsedDate).format("DD-MM-YY HH:mm:ss");
  };

  const getAgentCommissionList = (e) => {
    setLoading(true);
    dispatch(agentCommissionList())
      .then((response) => {
        setCommissionList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  };
  useEffect(() => {
    getAgentCommissionList();
    document.body.style.backgroundImage = "";

    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  const navigate = useNavigate();
  const addNewCommission = (e) => {
    navigate("/add-commission-group");
  };

  const handleRowExpand = (row, data) => {
    const newExpanded = { ...expanded };
    newExpanded[data.group_id] = !expanded[data.group_id];
    setExpanded(newExpanded);
  };
  const conditionalRowStyles = [
    {
      when: (data) => data.group_id && !!expanded[data.group_id],
      style: {
        backgroundColor: "#3280dd !important",
        color: "white",
      },
    },
  ];
  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
  };

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  };
  const filteredData = commissionList.filter((row) =>
    Object.values(row).some((value) =>
      new RegExp(escapeRegExp(searchTerm), "i").test(value)
    )
  );

  const resetSearch = () => {
    setSearchTerm("");
  };
  const customExpandableIcon = {
    collapsed: <span className="collapsed-icon"></span>,
    expanded: <span className="expand-icon"></span>,
  };

  const suspendMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Suspend",
      modalId: "statusChangeCommisonSuspend",
    });
  };

  const resumeMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Resume",
      modalId: "statusChangeCommisionLimitResume",
    });
  };

  useEffect(() => {
        if (filteredData?.length) {
          const element = document.getElementsByClassName("sc-bHCmUC");
          const childElement = element[0].children;
          for (let i = 0; i < childElement?.length; i++) {
            const ele = childElement[i].id.split("-")[1];
            if (Number(ele) % 2 === 0) {
              childElement[i].classList.add("odd-transaction-table");
            } else {
              childElement[i].classList.add("even-transaction-table");

            }
          }
        }
      }, [filteredData]);
  
  return (
    <div>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="container" style={{ backgroundColor: "white" }}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active tbbtn"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                onClick={resetSearch}
              >
                Commission Group ({commissionList.length})
              </button>
            </div>
          </nav>

          <div className="filterBtn">
            <SearchTable
              searchTerm={searchTerm}
              handleSearchChange={handleSearchChange}
            />
            <div className="dt-buttons ui-buttonset">
              <a
                className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg"
                tabIndex={0}
                aria-controls="examplemgm"
              >
                <span className="ui-button-text" onClick={addNewCommission}>
                  Add Commission Group
                </span>
              </a>
            </div>
          </div>
          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px" }}
          >
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
              style={{ position: "relative" }}
            >
              <div className="multi">
                <a
                  className="nav-link dropdown-toggle news fell jhb"
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    opacity: selectedRows.length > 0 ? 1 : "",
                    pointerEvents: selectedRows.length > 0 ? "auto" : "none",
                  }}
                >
                  <i className="fa fa-ellipsis-h" aria-hidden="true" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end mbv"
                  id="nvb"
                  aria-labelledby="navbarDropdown"
                  style={{}}
                >
                  {/* <li>
                              <a className="dropdown-item modal__button" id="open-modal" href="javascript:void(0);" style={{fontSize: '13px'}}>Limits</a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#!" style={{fontSize: '13px'}}>Commission</a>
                            </li> */}
                  <li onClick={suspendMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Suspend
                    </a>
                  </li>
                  <li onClick={resumeMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Activate
                    </a>
                  </li>
                </ul>
                <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" />
              </div>
              <DataTable
                key={dataTableKey}
                columns={columns}
                data={filteredData}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                conditionalRowStyles={conditionalRowStyles}
                paginationPerPage={rowsPerPage}
                onSelectedRowsChange={selectRows}
                customStyles={customDataTableStyles}
              />
            </div>
          </div>
        </div>
      </div>
      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={() => updateStatus(false)}
        status={row.status}
        modalId={row.modalId}
      ></Confirmation>
    </div>
  );
};
// function mapStateToProps(state) {
//   const userData = state.authReducer.user;
//   return { userData };
// }
// export default connect(mapStateToProps)(AgentCommissionListView);
export default AgentCommissionListView;
